import React, { Component } from "react";
import { Button, TextField, Select, MenuItem, FormControl } from "@material-ui/core";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import "./StaffActRoster.css";

class StaffActPaginationToolbar extends Component {
    state = {
        pageInputValue: "1"
    };

    componentDidMount() {
        this.setState({ pageInputValue: String(this.props.currentPage) });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentPage !== this.props.currentPage) {
            this.setState({ pageInputValue: String(this.props.currentPage) });
        }
    }

    handlePreviousPage = () => {
        const { currentPage, onPageChange, disabled } = this.props;
        if (!disabled && currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    handleNextPage = () => {
        const { currentPage, isMore, onPageChange, disabled } = this.props;
        if (!disabled && isMore) {
            onPageChange(currentPage + 1);
        }
    };

    handlePageInputChange = (e) => {
        this.setState({ pageInputValue: e.target.value });
    };

    handlePageInputKeyDown = (e) => {
        if (e.key === "Enter") {
            this.handlePageInputBlur();
        }
    };

    handlePageInputBlur = () => {
        const { pageInputValue } = this.state;
        const { onPageChange, disabled } = this.props;
        const pageNum = Number(pageInputValue);
        
        if (!disabled && Number.isSafeInteger(pageNum) && pageNum >= 1 &&
            Number.isSafeInteger(pageNum * this.props.pageSize)) {
            onPageChange(pageNum);
        } else {
            this.setState({ pageInputValue: String(this.props.currentPage) });
        }
    };

    handlePageSizeChange = (e) => {
        const { onPageSizeChange } = this.props;
        if (onPageSizeChange && !this.props.disabled) {
            onPageSizeChange(e.target.value);
        }
    };

    handleLoadAll = () => {
        const { onLoadAll } = this.props;
        if (onLoadAll && !this.props.disabled) {
            onLoadAll();
        }
    };

    render() {
        const { 
            currentPage, 
            pageSize, 
            totalItems, 
            isMore,
            disabled,
            isAllLoaded
        } = this.props;
        const { pageInputValue } = this.state;

        const startItem = (currentPage - 1) * pageSize + 1;
        const endItem = startItem + totalItems - 1;

        if (isAllLoaded) {
            return (
                <div className="staff-pagination-toolbar staff-pagination-all-loaded">
                    <div className="staff-pagination-info">
                        <i className="fa fa-check-circle" style={{ color: "#4caf50", marginRight: 8 }}></i>
                        Showing all <strong>{totalItems}</strong> acts
                    </div>
                    <button 
                        className="staff-reset-pagination"
                        disabled={disabled}
                        onClick={() => this.props.onPageChange(1)}
                    >
                        Reset to paginated view
                    </button>
                </div>
            );
        }

        return (
            <div className="staff-pagination-toolbar">
                <div className="staff-pagination-left">
                    <div className="staff-page-size-select">
                        <span>Show:</span>
                        <FormControl variant="outlined" size="small">
                            <Select
                                value={pageSize}
                                disabled={disabled}
                                onChange={this.handlePageSizeChange}
                                className="staff-page-size-dropdown"
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </FormControl>
                        <span>per page</span>
                    </div>
                    <div className="staff-pagination-info">
                        {totalItems ? <>Showing <strong>{startItem}-{endItem}</strong> acts</> : "No matching acts on this page"}
                    </div>
                </div>

                <div className="staff-pagination-center">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={this.handlePreviousPage}
                        disabled={disabled || currentPage <= 1}
                        className="staff-pagination-btn"
                    >
                        <NavigateBeforeIcon fontSize="small" />
                        Prev
                    </Button>

                    <div className="staff-page-selector">
                        <span>Page</span>
                        <TextField
                            value={pageInputValue}
                            disabled={disabled}
                            onChange={this.handlePageInputChange}
                            onBlur={this.handlePageInputBlur}
                            onKeyDown={this.handlePageInputKeyDown}
                            variant="outlined"
                            size="small"
                            className="staff-page-input"
                            inputProps={{ style: { textAlign: "center", padding: "6px 8px", width: 40 } }}
                        />
                    </div>

                    <Button
                        variant="contained"
                        size="small"
                        onClick={this.handleNextPage}
                        disabled={disabled || !isMore}
                        className="staff-pagination-btn staff-pagination-btn-primary"
                    >
                        Next
                        <NavigateNextIcon fontSize="small" />
                    </Button>
                </div>

                <div className="staff-pagination-right">
                    {(isMore || currentPage > 1) && (
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={this.handleLoadAll}
                            disabled={disabled}
                            className="staff-load-all-btn"
                        >
                            Load All
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

export default StaffActPaginationToolbar;
